"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5171],{

/***/ 2992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ HomeMobile; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Container/Container.js
var Container = __webpack_require__(32223);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Flex/Flex.js
var Flex = __webpack_require__(92833);
// EXTERNAL MODULE: ./src/components/HotelsTonight/HotelsTonight.tsx + 1 modules
var HotelsTonight = __webpack_require__(24003);
// EXTERNAL MODULE: ./src/components/PromoFeatureBox.tsx + 4 modules
var PromoFeatureBox = __webpack_require__(79514);
// EXTERNAL MODULE: ./src/components/SmsOptIn/index.tsx + 3 modules
var SmsOptIn = __webpack_require__(90924);
// EXTERNAL MODULE: ./src/components/ConditionalRender/index.tsx + 2 modules
var ConditionalRender = __webpack_require__(93314);
// EXTERNAL MODULE: ./src/hooks/useMostRecentFutureBooking.ts
var useMostRecentFutureBooking = __webpack_require__(81850);
// EXTERNAL MODULE: ./src/hooks/useExpressDealModal.ts
var useExpressDealModal = __webpack_require__(77185);
// EXTERNAL MODULE: ./src/components/CrossSell/index.tsx + 16 modules
var CrossSell = __webpack_require__(90020);
// EXTERNAL MODULE: ./src/components/EmailSignUp/index.tsx + 7 modules
var EmailSignUp = __webpack_require__(86229);
// EXTERNAL MODULE: ./src/components/Promos/MarketingTout/MarketingTout.tsx
var MarketingTout = __webpack_require__(51453);
// EXTERNAL MODULE: ./src/components/ExtendStay/index.tsx + 2 modules
var ExtendStay = __webpack_require__(38292);
// EXTERNAL MODULE: ./src/hooks/useExtendStayBooking.ts
var useExtendStayBooking = __webpack_require__(83405);
// EXTERNAL MODULE: ./src/context/SearchFormContext.tsx
var SearchFormContext = __webpack_require__(51069);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/StyledHeading/index.tsx
var StyledHeading = __webpack_require__(29293);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/utils/utils.js
var utils = __webpack_require__(67113);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Link/Link.js
var Link = __webpack_require__(40869);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Text/Text.js + 2 modules
var Text = __webpack_require__(23720);
// EXTERNAL MODULE: ./src/components/ProductIcon.tsx
var ProductIcon = __webpack_require__(64298);
// EXTERNAL MODULE: ./src/components/SearchForm/constants.ts
var constants = __webpack_require__(67685);
;// CONCATENATED MODULE: ./src/components/MobileTabStrip/MobileTabStrip.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 2px solid\n    ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &:focus,\n  &:visited,\n  &:hover {\n    text-decoration: none;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var IconWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-2a7e0d70-0"
})(_templateObject(), function(props) {
    return props.isActive ? (0,utils/* getPaletteColor */.ow)("primary.base") : "transparent";
});
var TabWrapper = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).withConfig({
    componentId: "sc-2a7e0d70-1"
})(_templateObject1());
function MobileTabStrip(param) {
    var _activeTab = param.activeTab, activeTab = _activeTab === void 0 ? "hotels" : _activeTab, _productTabs = param.productTabs, productTabs = _productTabs === void 0 ? constants/* PRODUCT_TABS */.bW : _productTabs, _onTabClick = param.onTabClick, onTabClick = _onTabClick === void 0 ? function() {
    // empty default function
    } : _onTabClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
        role: "tablist",
        "aria-label": "Types of travel",
        justifyContent: "space-around",
        py: 2,
        mb: "10px",
        children: productTabs.map(function(tab) {
            var isActive = tab.id === activeTab;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabWrapper, {
                width: 1 / productTabs.length,
                role: "tab",
                "aria-selected": isActive,
                "aria-controls": "panel-".concat(tab.id),
                "aria-label": "Search for ".concat(tab.id),
                id: "tab-".concat(tab.id),
                "data-testid": tab.autobotID,
                onClick: function() {
                    onTabClick(tab.id);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, {
                        mx: "auto",
                        mb: 1,
                        width: 48,
                        height: 48,
                        pt: 1,
                        bg: isActive ? "primary.light" : "background",
                        borderRadius: "50%",
                        alignItems: "center",
                        justifyContent: "center",
                        isActive: isActive,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductIcon/* default */.Z, {
                            name: tab.id,
                            isActive: isActive,
                            size: "32px"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        fontSize: 1,
                        textAlign: "center",
                        lineHeight: "16px",
                        color: "primary",
                        fontWeight: isActive ? "bold" : 100,
                        children: tab.tabText
                    })
                ]
            }, tab.id);
        })
    });
}

;// CONCATENATED MODULE: ./src/utils/getCurrentTab.ts
function getCurrentTab(query) {
    return typeof query.tab === "string" && query.tab ? query.tab : "hotels";
}

// EXTERNAL MODULE: ./src/utils/analytics.ts
var analytics = __webpack_require__(94738);
// EXTERNAL MODULE: ./src/constants/analytics.ts
var constants_analytics = __webpack_require__(66487);
// EXTERNAL MODULE: ./src/hooks/useSeti.ts
var useSeti = __webpack_require__(39939);
// EXTERNAL MODULE: ./src/hooks/useContentfulSearchFormHeadlines.ts
var useContentfulSearchFormHeadlines = __webpack_require__(98673);
;// CONCATENATED MODULE: ./src/components/SearchForm/customHooks/useHeadlineValues.ts


var useHeadlineValues = function(currentTab) {
    var hotels = (0,useContentfulSearchFormHeadlines/* default */.Z)("searchFormHotels", currentTab === "hotels");
    var flights = (0,useContentfulSearchFormHeadlines/* default */.Z)("searchFormFlights", currentTab === "flights");
    var vacations = (0,useContentfulSearchFormHeadlines/* default */.Z)("searchFormVacations", currentTab === "vacations");
    var cars = (0,useContentfulSearchFormHeadlines/* default */.Z)("searchFormCars", currentTab === "cars");
    var cruises = (0,useContentfulSearchFormHeadlines/* default */.Z)("searchFormCruises", currentTab === "cruises");
    return {
        hotels: hotels || constants/* HEADERS.hotels */.ob.hotels,
        flights: flights || constants/* HEADERS.flights */.ob.flights,
        vacations: vacations || constants/* HEADERS.vacations */.ob.vacations,
        cars: cars || constants/* HEADERS.cars */.ob.cars,
        cruises: cruises || constants/* HEADERS.cruises */.ob.cruises
    };
};
/* harmony default export */ var customHooks_useHeadlineValues = (useHeadlineValues);

// EXTERNAL MODULE: ./src/components/Hotels/SearchForm/Form.tsx + 8 modules
var Form = __webpack_require__(49515);
// EXTERNAL MODULE: ./src/components/Flights/SearchForm/Form.tsx + 6 modules
var SearchForm_Form = __webpack_require__(93853);
// EXTERNAL MODULE: ./src/components/Cars/SearchForm/Form.tsx + 4 modules
var Cars_SearchForm_Form = __webpack_require__(17767);
// EXTERNAL MODULE: ./src/components/Packages/SearchForm/Form.tsx + 4 modules
var Packages_SearchForm_Form = __webpack_require__(32118);
// EXTERNAL MODULE: ./src/components/Cruises/SearchForm/Form.tsx + 3 modules
var Cruises_SearchForm_Form = __webpack_require__(73345);
// EXTERNAL MODULE: ./src/components/Packages/SearchForm/utils.ts
var SearchForm_utils = __webpack_require__(360);
// EXTERNAL MODULE: ./src/components/Cars/SearchForm/utils.ts
var Cars_SearchForm_utils = __webpack_require__(60837);
// EXTERNAL MODULE: ./src/components/Flights/SearchForm/utils.ts
var Flights_SearchForm_utils = __webpack_require__(91753);
// EXTERNAL MODULE: ./src/components/Hotels/SearchForm/utils.ts
var Hotels_SearchForm_utils = __webpack_require__(84822);
// EXTERNAL MODULE: ./src/components/SearchForm/Bumpers.tsx + 1 modules
var Bumpers = __webpack_require__(51197);
;// CONCATENATED MODULE: ./src/components/SearchForm/utils/getProductCategoryMobile.tsx












var getProductCategoryMobile = function(productType, values, setLocation) {
    switch(productType){
        case "flights":
            return {
                component: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchForm_Form/* default */.Z, {
                    onSubmit: Flights_SearchForm_utils/* onSubmit */.MI
                }),
                bumper: /*#__PURE__*/ (0,jsx_runtime.jsx)(Bumpers/* FlightsBumper */.HG, {}),
                headline: values.flights.mobileHeadline
            };
        case "cars":
            return {
                component: /*#__PURE__*/ (0,jsx_runtime.jsx)(Cars_SearchForm_Form/* default */.Z, {
                    onSubmit: Cars_SearchForm_utils/* handleSubmitForCars */.Rh
                }),
                bumper: /*#__PURE__*/ (0,jsx_runtime.jsx)(Bumpers/* CarsBumper */.IQ, {}),
                headline: values.cars.mobileHeadline
            };
        case "vacations":
            return {
                component: /*#__PURE__*/ (0,jsx_runtime.jsx)(Packages_SearchForm_Form/* default */.Z, {
                    onSubmit: SearchForm_utils/* onSubmit */.MI,
                    isLandingPage: false
                }),
                bumper: /*#__PURE__*/ (0,jsx_runtime.jsx)(Bumpers/* VacationBumper */.UB, {}),
                headline: values.vacations.mobileHeadline
            };
        case "cruises":
            return {
                component: /*#__PURE__*/ (0,jsx_runtime.jsx)(Cruises_SearchForm_Form/* default */.Z, {}),
                bumper: /*#__PURE__*/ (0,jsx_runtime.jsx)(Bumpers/* CruiseBumper */.d7, {}),
                headline: values.cruises.mobileHeadline
            };
        default:
            return {
                component: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default */.Z, {
                    onSubmit: Hotels_SearchForm_utils/* handleSubmitForHotels */.Ky,
                    setLocation: setLocation
                }),
                bumper: /*#__PURE__*/ (0,jsx_runtime.jsx)(Bumpers/* HotelsBumper */.np, {}),
                headline: values.hotels.mobileHeadline
            };
    }
};
/* harmony default export */ var utils_getProductCategoryMobile = (getProductCategoryMobile);

;// CONCATENATED MODULE: ./src/components/SearchForm/utils/getProductCategoryMobileExperiment.tsx












var getProductCategoryMobileExperiment = function(productType, values, setLocation) {
    switch(productType){
        case "flights":
            return {
                component: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchForm_Form/* default */.Z, {
                    onSubmit: Flights_SearchForm_utils/* onSubmit */.MI
                }),
                bumper: /*#__PURE__*/ (0,jsx_runtime.jsx)(Bumpers/* FlightsBumper */.HG, {})
            };
        case "cars":
            return {
                component: /*#__PURE__*/ (0,jsx_runtime.jsx)(Cars_SearchForm_Form/* default */.Z, {
                    onSubmit: Cars_SearchForm_utils/* handleSubmitForCars */.Rh
                }),
                bumper: /*#__PURE__*/ (0,jsx_runtime.jsx)(Bumpers/* CarsBumper */.IQ, {})
            };
        case "vacations":
            return {
                component: /*#__PURE__*/ (0,jsx_runtime.jsx)(Packages_SearchForm_Form/* default */.Z, {
                    onSubmit: SearchForm_utils/* onSubmit */.MI,
                    isLandingPage: false
                }),
                bumper: /*#__PURE__*/ (0,jsx_runtime.jsx)(Bumpers/* VacationBumper */.UB, {})
            };
        case "cruises":
            return {
                component: /*#__PURE__*/ (0,jsx_runtime.jsx)(Cruises_SearchForm_Form/* default */.Z, {}),
                bumper: /*#__PURE__*/ (0,jsx_runtime.jsx)(Bumpers/* CruiseBumper */.d7, {})
            };
        default:
            return {
                component: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default */.Z, {
                    onSubmit: Hotels_SearchForm_utils/* handleSubmitForHotels */.Ky,
                    setLocation: setLocation
                }),
                bumper: /*#__PURE__*/ (0,jsx_runtime.jsx)(Bumpers/* HotelsBumper */.np, {}),
                headline: values.hotels.mobileHeadline
            };
    }
};
/* harmony default export */ var utils_getProductCategoryMobileExperiment = (getProductCategoryMobileExperiment);

// EXTERNAL MODULE: ./src/context/BootstrapDataContext.tsx
var BootstrapDataContext = __webpack_require__(68464);
// EXTERNAL MODULE: ./src/hooks/useSEMSearchHeadline.ts
var useSEMSearchHeadline = __webpack_require__(32881);
// EXTERNAL MODULE: ./src/constants/content.ts
var content = __webpack_require__(66410);
// EXTERNAL MODULE: ./src/hooks/useCityNameInFormHeadlineForSEM.ts
var useCityNameInFormHeadlineForSEM = __webpack_require__(40813);
;// CONCATENATED MODULE: ./src/components/SearchForm/customHooks/useFormatHotelHeadline.ts





var getHeadlineWithFirstName = function(template, firstName) {
    return firstName ? template.replace("{firstName}", firstName) : content/* GREETING_DESKTOP */.gL;
};
var useFormatHotelHeadlines = function(values, hideNonSemHeadline) {
    var ref = (0,react.useContext)(BootstrapDataContext/* default */.Z), firstName = ref.customer.firstName, _signInStatus = ref.signInStatus, signedIn = _signInStatus.signedIn, passiveSignIn = _signInStatus.passiveSignIn;
    var isSignedIn = signedIn || passiveSignIn;
    var ref1 = (0,react.useState)(), location = ref1[0], setLocation = ref1[1];
    var SEMHeadline = (0,useSEMSearchHeadline/* default */.Z)();
    var prePopHeadline = (0,useCityNameInFormHeadlineForSEM/* default */.Z)(location);
    var headlineWithName = getHeadlineWithFirstName(content/* default.homepage.vip.headlineWithName */.ZP.homepage.vip.headlineWithName, firstName);
    var defaultHeadline = isSignedIn ? headlineWithName : values.hotels.headline;
    var hotelHeadline = prePopHeadline || SEMHeadline || (hideNonSemHeadline ? null : defaultHeadline);
    return {
        hotelHeadline: hotelHeadline,
        setLocation: setLocation
    };
};
/* harmony default export */ var useFormatHotelHeadline = (useFormatHotelHeadlines);

// EXTERNAL MODULE: ./src/components/Hotels/Hero/HeroMobile.tsx + 2 modules
var HeroMobile = __webpack_require__(83018);
;// CONCATENATED MODULE: ./src/components/SearchForm/SearchFormMobile.tsx

















function SearchForm() {
    var ref = (0,router.useRouter)(), push = ref.push, query = ref.query, pathname = ref.pathname;
    var currentTab = getCurrentTab(query);
    var ref1 = (0,react.useState)(currentTab), activeTabName = ref1[0], setActiveTabName = ref1[1];
    var mobileValues = customHooks_useHeadlineValues(currentTab);
    var isSetiNoHeadings = (0,useSeti/* default */.Z)("MBL_HP_NO_HEADINGS") === "VARIANT";
    var ref2 = useFormatHotelHeadline(mobileValues, isSetiNoHeadings), hotelHeadline = ref2.hotelHeadline, setLocation = ref2.setLocation;
    var getProductExperimentFunction = isSetiNoHeadings ? utils_getProductCategoryMobileExperiment : utils_getProductCategoryMobile;
    var updatedMobileValues = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, mobileValues), {
        hotels: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, mobileValues.hotels), {
            mobileHeadline: hotelHeadline
        })
    });
    var ref3 = (0,react.useState)(getProductExperimentFunction(currentTab, updatedMobileValues, setLocation)), formState = ref3[0], setFormState = ref3[1];
    var handleOnTabClick = function(productType) {
        setActiveTabName(productType);
        push({
            pathname: pathname,
            query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query), {
                tab: productType
            })
        }, undefined, {
            shallow: true
        });
        analytics/* default.fireEvent */.Z.fireEvent({
            action: "Tab",
            label: productType,
            category: constants_analytics/* ANALYTICS_CATEGORY_HOME */.DG
        });
        var selectedProductCategory = getProductExperimentFunction(productType, updatedMobileValues, setLocation);
        setFormState(selectedProductCategory);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        mb: 4,
        mt: 2,
        boxShadowSize: "xl",
        rounded: "round",
        borderRadius: "2xl",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileTabStrip, {
                activeTab: activeTabName,
                onTabClick: handleOnTabClick
            }),
            activeTabName === "hotels" && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroMobile/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                px: 3,
                children: [
                    formState.headline && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeading/* default */.Z, {
                        tag: "h1",
                        color: "text.heading",
                        textStyle: "heading3",
                        text: formState.headline
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        mt: formState.headline ? 3 : 0,
                        children: formState.component
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mt: 3,
                children: formState.bumper
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@pcln/marketing/dist/esm/SilhouetteMarketingModule/SilhouetteMarketingModule.js + 2 modules
var SilhouetteMarketingModule = __webpack_require__(26070);
// EXTERNAL MODULE: ./src/constants/promotions/branded-marketing.ts
var branded_marketing = __webpack_require__(69325);
// EXTERNAL MODULE: ./node_modules/@pcln/cards/lib-esm/ActionCard/ActionCard.js + 1 modules
var ActionCard = __webpack_require__(44130);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Bag.js
var Bag = __webpack_require__(88813);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Help.js
var Help = __webpack_require__(45932);
// EXTERNAL MODULE: ./src/hooks/smsOptIn/useSmsDisclaimerQueryArgs.ts
var useSmsDisclaimerQueryArgs = __webpack_require__(95846);
// EXTERNAL MODULE: ./src/components/AppDownloadOptIn/utils.tsx
var AppDownloadOptIn_utils = __webpack_require__(79876);
// EXTERNAL MODULE: ./src/components/Hotels/ExpressDeal/ExpressDealModal.tsx
var ExpressDealModal = __webpack_require__(55173);
// EXTERNAL MODULE: ./src/components/LayoutComponentWrapper/index.tsx
var LayoutComponentWrapper = __webpack_require__(47418);
;// CONCATENATED MODULE: ./src/components/Home/HomeMobile.tsx

























function HomeMobile() {
    var isOpen = (0,useExpressDealModal/* default */.Z)().isOpen;
    var mostRecentFutureBooking = (0,useMostRecentFutureBooking/* default */.Z)();
    var extendData = (0,useExtendStayBooking/* default */.Z)();
    var smsDisclaimerQueryArgs = (0,useSmsDisclaimerQueryArgs/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpressDealModal/* default */.Z, {
                isModalOpen: isOpen
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchFormContext/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchForm, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                m: 3,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        mb: extendData || mostRecentFutureBooking ? 5 : 0,
                        children: extendData ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ExtendStay/* default */.Z, (0,_object_spread/* default */.Z)({}, extendData)) : mostRecentFutureBooking && /*#__PURE__*/ (0,jsx_runtime.jsx)(CrossSell/* default */.Z, {
                            booking: mostRecentFutureBooking
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoFeatureBox/* default */.Z, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                m: 3,
                mt: "48px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalRender/* default */.ZP, {
                        experimentCode: "HP_SMS_COMPONENT",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalRender/* Experiment */.KS, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SmsOptIn/* default */.Z, {
                                disclaimerQueryArgs: smsDisclaimerQueryArgs
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketingTout/* default */.Z, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LayoutComponentWrapper/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SilhouetteMarketingModule/* default */.Z, (0,_object_spread/* default */.Z)({}, branded_marketing/* default */.Z))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                m: 3,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HotelsTonight/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        textAlign: "center",
                        mt: 4,
                        width: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            id: "div-gpt-ad-1544641976893-0"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalRender/* default */.ZP, {
                experimentCode: "HP_APPBANNER_TRIO",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalRender/* Experiment */.KS, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        m: 3,
                        flexDirection: "column",
                        style: {
                            gap: 16
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionCard/* default */.Z, {
                                titleWidth: "200px",
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Bag/* default */.Z, {
                                    color: "primary"
                                }),
                                title: "My Trips",
                                caption: "Quickly find your booking reservations",
                                isIconRounded: false,
                                onClick: AppDownloadOptIn_utils/* trackMyTrips */.y3
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionCard/* default */.Z, {
                                titleWidth: "200px",
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Help/* default */.Z, {}),
                                title: "Help Center",
                                isIconRounded: false,
                                caption: "We are always Here for you - reach us 24hrs a day, 7 days a week",
                                onClick: AppDownloadOptIn_utils/* trackHelpCenter */.Tl
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailSignUp/* EmailSignUpToast */.Zz, {
                sourceId: "LANDING_HOME_TOAST_MWEB",
                isMobile: true
            })
        ]
    });
}


/***/ }),

/***/ 83018:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ HeroMobile; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Image/Image.js
var Image = __webpack_require__(38489);
// EXTERNAL MODULE: ./src/context/BootstrapDataContext.tsx
var BootstrapDataContext = __webpack_require__(68464);
;// CONCATENATED MODULE: ./src/hooks/useMobileHeroCityImage.ts


var imageFolder = "https://s1.pclncdn.com/design-assets/hero/city/";
var citiesIdsWithImages = [
    3000000247,
    3000000983,
    3000001284,
    3000001349,
    3000001372,
    3000001401,
    3000001438,
    3000001468,
    3000001750,
    3000001947,
    3000002028,
    3000002085,
    3000002228,
    3000002241,
    3000002244,
    3000002250,
    3000002557,
    3000002573,
    3000003032,
    3000003192,
    3000003204,
    3000003249,
    3000003263,
    3000003311,
    3000003349,
    3000003394,
    3000003430,
    3000003431,
    3000003496,
    3000003899,
    3000004031,
    3000004976,
    3000005381,
    3000006556,
    3000007853,
    3000007866,
    3000008192,
    3000008434,
    3000008602,
    3000008983,
    3000010039,
    3000010974,
    3000011692,
    3000011975,
    3000012799,
    3000012874,
    3000012928,
    3000012998,
    3000013221,
    3000014046,
    3000014119,
    3000014521,
    3000014999,
    3000015284,
    3000015300,
    3000015330,
    3000016152,
    3000016793,
    3000016799,
    3000016809,
    3000017780,
    3000017897,
    3000018178,
    3000018774,
    3000019204,
    3000019211,
    3000019687,
    3000019699,
    3000019754,
    3000019836,
    3000020244,
    3000020394,
    3000020556,
    3000020605,
    3000020633,
    3000020669,
    3000020830,
    3000020845,
    3000020856,
    3000021082,
    3000021147,
    3000021192,
    3000021212,
    3000021312,
    3000021337,
    3000021763,
    3000022148,
    3000022704,
    3000022821,
    3000022847,
    3000023414,
    3000023431,
    3000023843,
    3000023880,
    3000024967,
    3000031041,
    3000033184,
    3000033452,
    3000000013,
    3000000412,
    3000000443,
    3000000511,
    3000000514,
    3000000544,
    3000000859,
    3000000867,
    3000000936,
    3000001121,
    3000001294,
    3000001310,
    3000001330,
    3000001374,
    3000001391,
    3000001409,
    3000001489,
    3000001526,
    3000001562,
    3000001563,
    3000001624,
    3000001839,
    3000001942,
    3000002089,
    3000002117,
    3000002237,
    3000002269,
    3000002270,
    3000002273,
    3000002277,
    3000002374,
    3000002512,
    3000002591,
    3000002738,
    3000002914,
    3000003025,
    3000003042,
    3000003075,
    3000003106,
    3000003142,
    3000003143,
    3000003147,
    3000003159,
    3000003165,
    3000003167,
    3000003178,
    3000003195,
    3000003196,
    3000003198,
    3000003232,
    3000003255,
    3000003260,
    3000003299,
    3000003307,
    3000003324,
    3000003366,
    3000003369,
    3000003384,
    3000003397,
    3000003405,
    3000003441,
    3000003451,
    3000003495,
    3000003499,
    3000003627,
    3000003968,
    3000004027,
    3000004038,
    3000004060,
    3000004115,
    3000004219,
    3000004284,
    3000004304,
    3000004320,
    3000004819,
    3000004996,
    3000005056,
    3000005106,
    3000005172,
    3000006345,
    3000006383,
    3000006459,
    3000006466,
    3000006483,
    3000006530,
    3000006647,
    3000006689,
    3000006796,
    3000006817,
    3000007481,
    3000007565,
    3000008361,
    3000008506,
    3000008619,
    3000008975,
    3000009098,
    3000009206,
    3000009340,
    3000009344,
    3000009345,
    3000009462,
    3000009626,
    3000009772,
    3000009863,
    3000009942,
    3000010004,
    3000010083,
    3000010151,
    3000010449,
    3000010704,
    3000011097,
    3000011126,
    3000011364,
    3000012014,
    3000012156,
    3000012270,
    3000012349,
    3000012490,
    3000012499,
    3000012507,
    3000012663,
    3000013149,
    3000013383,
    3000013388,
    3000014407,
    3000014456,
    3000014705,
    3000014810,
    3000015206,
    3000015277,
    3000015285,
    3000015289,
    3000015470,
    3000015474,
    3000016162,
    3000016338,
    3000016474,
    3000016662,
    3000016689,
    3000016773,
    3000016835,
    3000016853,
    3000017052,
    3000017059,
    3000017209,
    3000017287,
    3000017358,
    3000017372,
    3000017961,
    3000017974,
    3000017975,
    3000018046,
    3000018119,
    3000018156,
    3000018202,
    3000018209,
    3000018798,
    3000018900,
    3000019617,
    3000019626,
    3000019733,
    3000019766,
    3000019831,
    3000019878,
    3000019910,
    3000020030,
    3000020217,
    3000020489,
    3000020632,
    3000020813,
    3000021054,
    3000021197,
    3000021455,
    3000021596,
    3000021660,
    3000021770,
    3000021825,
    3000021931,
    3000021939,
    3000022021,
    3000022057,
    3000022102,
    3000022119,
    3000022125,
    3000022136,
    3000022145,
    3000022190,
    3000022201,
    3000022300,
    3000022428,
    3000022476,
    3000022627,
    3000022633,
    3000022711,
    3000023134,
    3000023742,
    3000024139,
    3000024768,
    3000024950,
    3000025013,
    3000025100,
    3000025150,
    3000030122,
    3000030632,
    3000030844,
    3000030999,
    3000031000,
    3000031085,
    3000031161,
    3000032664,
    3000033051,
    3000033144,
    3000033237,
    3000033518,
    3000035653,
    3000035763,
    3000035812,
    3000035821,
    3000035822,
    3000035823,
    3000035824,
    3000035825,
    3000035826,
    3000035827,
    3000035833,
    3000035879,
    3000035880,
    3000035882,
    3000035886,
    3000035887,
    3000035889,
    3000035890,
    3000035894,
    3000035895,
    3000035919,
    3000035932,
    3000035938,
    3000040031,
    3000040045,
    3000060010,
    3000060012,
    3000060016,
    3000060055,
    3000060262,
    3000060600,
    3000060955,
    3000061777,
    3000061779,
    3000061781,
    3000061787,
    3000062401,
    3000062417,
    3000070000,
    3000070002,
    3000080002,
    3000090052,
    3000090246,
    3000090568,
    3000090588,
    3000092223,
    3000096245,
    3000096321,
    3000097071,
    3000097769,
    5000016489,
    5000024971,
    5000025185,
    5000090279,
    5000457862,
    5000461998,
    5000494493,
    5000495528,
    5000495791,
    5000503659,
    5000503670
];
function useMobileHeroCityImage() {
    var ref;
    var prePopData = (0,react.useContext)(BootstrapDataContext/* default */.Z).prePopData;
    var endLocation = prePopData === null || prePopData === void 0 ? void 0 : (ref = prePopData.hotels) === null || ref === void 0 ? void 0 : ref.endLocation;
    var hasCity = !!(endLocation === null || endLocation === void 0 ? void 0 : endLocation.cityName) && (endLocation === null || endLocation === void 0 ? void 0 : endLocation.type) === "CITY";
    var cityId = Number(endLocation && endLocation.cityID);
    var hasCityImage = hasCity && citiesIdsWithImages.includes(cityId);
    return hasCityImage ? {
        src: "".concat(imageFolder).concat(endLocation === null || endLocation === void 0 ? void 0 : endLocation.cityID, ".jpg?opto&auto=avif,webp&width=500&fit=bounds,safe"),
        altName: endLocation === null || endLocation === void 0 ? void 0 : endLocation.cityName
    } : null;
}

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/SearchForm/constants.ts
var constants = __webpack_require__(67685);
;// CONCATENATED MODULE: ./src/hooks/useMobileHeroAmenityImage.ts


var useMobileHeroAmenityImage_imageFolder = "https://s1.pclncdn.com/design-assets/hero/amenity/";
function useMobileHeroAmenityImage() {
    var ref;
    var query = (0,router.useRouter)().query;
    var SEMSearch = query.SEMSearch, SEMSEARCH = query.SEMSEARCH;
    var semSearchParam = (ref = SEMSearch || SEMSEARCH) === null || ref === void 0 ? void 0 : ref.toUpperCase();
    var isSemSearchAmenity = semSearchParam !== undefined && constants/* AMENITIES */.RN[semSearchParam] !== undefined;
    return isSemSearchAmenity ? {
        src: "".concat(useMobileHeroAmenityImage_imageFolder).concat(semSearchParam, ".jpg?opto&auto=avif,webp&crop=3:1"),
        altName: semSearchParam
    } : null;
}

;// CONCATENATED MODULE: ./src/components/Hotels/Hero/HeroMobile.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: 110px;\n  overflow: hidden;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var ImageWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-382351a6-0"
})(_templateObject());
function HeroMobile() {
    var mobileHeroCityImage = useMobileHeroCityImage();
    var mobileHeroAmenityImage = useMobileHeroAmenityImage();
    var mobileHeroImage = mobileHeroCityImage || mobileHeroAmenityImage;
    return mobileHeroImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
        borderRadius: "lg",
        m: 3,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
            src: mobileHeroImage.src,
            alt: "Picture of ".concat(mobileHeroImage.altName),
            className: "mobile-hero-image"
        })
    }) : null;
}


/***/ }),

/***/ 24003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ HotelsTonight; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Button/Button.js
var Button = __webpack_require__(8316);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Card/Card.js
var Card = __webpack_require__(70609);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Flex/Flex.js
var Flex = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Text/Text.js + 2 modules
var Text = __webpack_require__(23720);
// EXTERNAL MODULE: ./src/utils/date-helper.tsx
var date_helper = __webpack_require__(68511);
// EXTERNAL MODULE: ./src/utils/analytics.ts
var analytics = __webpack_require__(94738);
// EXTERNAL MODULE: ./src/hooks/useGeoPosition.ts
var useGeoPosition = __webpack_require__(29657);
;// CONCATENATED MODULE: ./src/components/HotelsTonight/SleepIcon.tsx


function SleepIcon(param) {
    var _width = param.width, width = _width === void 0 ? 20 : _width, _height = param.height, height = _height === void 0 ? 32 : _height, _color = param.color, color = _color === void 0 ? "#687B8E" : _color, _translateX = param.translateX, translateX = _translateX === void 0 ? -2 : _translateX, _translateY = param.translateY, translateY = _translateY === void 0 ? -3 : _translateY, _viewBoxHeight = param.viewBoxHeight, viewBoxHeight = _viewBoxHeight === void 0 ? 32 : _viewBoxHeight, _viewBoxWidth = param.viewBoxWidth, viewBoxWidth = _viewBoxWidth === void 0 ? 20 : _viewBoxWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: height,
        width: width,
        viewBox: "0 0 ".concat(viewBoxWidth, " ").concat(viewBoxHeight),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            fill: "none",
            fillRule: "evenodd",
            transform: "translate(".concat(translateX, " ").concat(translateY, ")"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M0 0L24 0 24 24 0 24z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: color,
                    fillRule: "nonzero",
                    d: "M2 15L5.63 15 2 19.2 2 21 8 21 8 19 4.37 19 8 14.8 8 13 2 13z"
                }),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: color,
                    fillRule: "nonzero",
                    d: "M9 10L12.63 10 9 14.2 9 16 15 16 15 14 11.37 14 15 9.8 15 8 9 8z"
                }),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: color,
                    fillRule: "nonzero",
                    d: "M16 5L19.63 5 16 9.2 16 11 22 11 22 9 18.37 9 22 4.8 22 3 16 3z"
                }),
                " "
            ]
        })
    });
}
/* harmony default export */ var HotelsTonight_SleepIcon = (SleepIcon);

// EXTERNAL MODULE: ./src/machines/currentLocationMachine.ts
var currentLocationMachine = __webpack_require__(71626);
// EXTERNAL MODULE: ./src/components/LayoutComponentWrapper/index.tsx
var LayoutComponentWrapper = __webpack_require__(47418);
;// CONCATENATED MODULE: ./src/components/HotelsTonight/HotelsTonight.tsx












function HotelsTonight() {
    var ref = (0,router.useRouter)(), _pathname = ref.pathname, pathname = _pathname === void 0 ? "/" : _pathname;
    var category = pathname === "/hotels" ? "HOTEL_HOME" : "PCLN_HOME";
    var ref1 = (0,useGeoPosition/* default */.Z)(), latitude = ref1.latitude, longitude = ref1.longitude;
    var relaxListingsCallBack = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, lat, lon, itemName, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(latitude !== null && longitude !== null)) return [
                            3,
                            5
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0,currentLocationMachine/* invokeFetchCurrentCityData */.N)(latitude, longitude)
                        ];
                    case 2:
                        ref = _state.sent(), lat = ref.lat, lon = ref.lon, itemName = ref.itemName;
                        window.location.href = "/relax/geo/".concat(itemName, "/").concat(lat, "/").concat(lon, "/from/").concat(date_helper/* defaultToday */.G4, "/to/").concat(date_helper/* defaultTomorrow */.Zx, "/rooms/1");
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        analytics/* default.fireEvent */.Z.fireEvent({
                            event: "Error",
                            category: category,
                            action: "Click",
                            data: error.toString()
                        });
                        window.location.href = "/hotels";
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            3,
                            6
                        ];
                    case 5:
                        analytics/* default.fireEvent */.Z.fireEvent({
                            event: "Error",
                            category: category,
                            action: "Click",
                            data: "Latitude/Longitude data could not be fetched"
                        });
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function relaxListingsCallBack() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleHotelsTonightClick = function(event) {
        event.preventDefault();
        analytics/* default.fireEvent */.Z.fireEvent({
            category: category,
            action: "Click",
            label: "Hotel Tonight"
        });
        relaxListingsCallBack();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LayoutComponentWrapper/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
            p: 3,
            width: 1,
            variation: "link",
            "data-testid": "HOMEPAGE_MWEB_TONIGHT_ONLY_SEARCH",
            onClick: handleHotelsTonightClick,
            target: "_self",
            size: "large",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                color: "background.lightest",
                boxShadowSize: "sm",
                br: "2px",
                borderRadius: "lg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    px: 2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            pr: 2,
                            mt: 2,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HotelsTonight_SleepIcon, {
                                color: "#004499",
                                height: 40,
                                translateX: -2,
                                translateY: -1,
                                viewBoxHeight: 20,
                                viewBoxWidth: 20,
                                width: 36
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            p: 2,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                    fontWeight: "bold",
                                    color: "black",
                                    fontSize: 2,
                                    textAlign: "left",
                                    children: "Need a hotel tonight?"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                    color: "text",
                                    mt: 2,
                                    fontSize: 0,
                                    textAlign: "left",
                                    children: "Find deals near you."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            width: "70px",
                            ml: "auto",
                            my: "auto",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                                size: "small",
                                width: 1,
                                children: "Search"
                            })
                        })
                    ]
                })
            })
        })
    });
}


/***/ })

}]);